import { render } from "./TabAsignacionProyecto.vue?vue&type=template&id=567e62ac"
import script from "./TabAsignacionProyecto.vue?vue&type=script&lang=js"
export * from "./TabAsignacionProyecto.vue?vue&type=script&lang=js"

import "./TabAsignacionProyecto.vue?vue&type=style&index=0&id=567e62ac&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__